import { render, staticRenderFns } from "./FooterMod.vue?vue&type=template&id=5dc36404&scoped=true&"
import script from "./FooterMod.vue?vue&type=script&lang=js&"
export * from "./FooterMod.vue?vue&type=script&lang=js&"
import style0 from "./FooterMod.vue?vue&type=style&index=0&id=5dc36404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc36404",
  null
  
)

export default component.exports